<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Select calendar') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12" style="margin-bottom: 10px">
          <div class="form-grop">
            <label>{{ _('Mode') }}:</label>
            <select class="form-control" v-model="mode">
              <option value="0">{{ _('Deny dates') }}</option>
              <option value="1">{{ _('Allow dates') }}</option>
            </select>
          </div>
        </div> 
        <div class="col-md-12">
          <div class="form-group">
            <label for="calendar">{{ _('Available calendars:') }}</label><br />
            <v-select :options="calendars" v-model="calendar" label="summary" keys="['id', 'summary']" :placeholder="_('Type to search calendars')" :create-item="false">
              <template v-slot:no-options="{ searching }">
                <template v-if="searching">
                  {{ _('No results found.') }}
                </template>
                <template v-else>{{ _('Type to search calendars') }}</template>
              </template>
            </v-select>
          </div>
        </div>
      </div>
      <div style="height: 300px"></div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="selectCalendar"><i class="fa fa-fw fa-save"></i> {{ _('OK') }}</button>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { mapGetters } from 'vuex'
import constants from '~/lib/constants'

export default {
  mixins: [constants],
  props: ['resource'],
  data () {
    return {
      calendar: null,
      calendars: [],
      mode: 1
    }
  },
  computed: {
    ...mapGetters(['shopId', 'baseDomain', 'apiKey'])
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    selectCalendar () {
      let obj = { calendar: this.calendar, mode: this.mode }
      if (this.resource) {
        Object.assign(obj, { resource: this.resource })
      }
      this.$emit('selectCalendar', obj)
    },
    async loadCalendars() {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/googlecalendars.json?apikey=' + this.apiKey)
      } catch(e) {
        return
      }
      if (!response.data || !response.data.sort) {
        this.calendars = []
        return
      }
      this.calendars = response.data.sort((a, b) => a.summary > b.summary ? 1 : -1)
    }
  },
  mounted () {
    this.loadCalendars()
  }
}
</script>